import baseApi from './base';

const fetchAll = () =>
  baseApi.request({
    method: 'get',
    url: '/departs'
  });

// 用于用户注册页面
const fetchDepartAll = () =>
  baseApi.request({
    method: 'get',
    url: '/departs/all'
  });

const fetchOne = id =>
  baseApi.request({
    method: 'get',
    url: `/departs/${id}`
  })

const modifyOne = data =>
  baseApi.request({
    method: 'patch',
    url: `/departs/${data.id}`,
    data
  })

  const modifyTrees = data =>
  baseApi.request({
    method: 'patch',
    url: '/departs/trees',
    data
  })

  const createOne = data =>
  baseApi.request({
    method: 'post',
    url: '/departs',
    data
  })

const deleteAll = data =>
  baseApi.request({
    method: 'delete',
    url: '/departs',
    data
  })

const downloadDepartTemplate = () =>
  baseApi.request({
    method: 'get',
    url: '/departs/download-template',
    responseType: 'blob'
  });

const uploadDeparts = data =>
baseApi.request({
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  method: 'post',
  url: '/departs/upload',
  responseType: 'blob',
  data
});

export {
  fetchAll,
  fetchDepartAll,
  fetchOne,
  modifyOne,
  modifyTrees,
  createOne,
  deleteAll,
  downloadDepartTemplate,
  uploadDeparts
}


// WEBPACK FOOTER //
// ./src/api/depart.js